import { formatDate } from '../../lib/dateFormat';

function formatPhone(value) {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function getSsnLast4(student) {
  const providedLast4 = String(student?.ssn_last4 || '').replace(/\D/g, '').slice(-4);
  if (providedLast4) return providedLast4;
  const ssnDigits = String(student?.ssn || '').replace(/\D/g, '');
  return ssnDigits ? ssnDigits.slice(-4) : '';
}

export function studentDisplayDetails(student) {
  const cityStateZip = [student?.city, student?.state, student?.zip].filter(Boolean).join(', ');

  return {
    identity: [
      student?.code ? `Code ${student.code}` : '',
      getSsnLast4(student) ? `SSN ${getSsnLast4(student)}` : '',
      student?.birth_date ? `DOB ${formatDate(student.birth_date)}` : '',
      student?.phone ? `Phone ${formatPhone(student.phone)}` : '',
      student?.email ? `Email ${student.email}` : '',
      student?.driver_number ? `DL ${student.driver_number}` : '',
      cityStateZip
    ].filter(Boolean),
    address: [student?.address, cityStateZip].filter(Boolean).join(', ')
  };
}
